import {
  CustomMonthsPeriodState,
  CustomWeeksPeriodState,
  UpdateMainFiltersPayload,
} from '../../reducers/main-filter/MainFiltersReducer';
import { MainFiltersActionType } from '../Type';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { RelativePeriod } from '@components/comparison-period-selector/Types';

export const updateMainFilters = (payload: UpdateMainFiltersPayload): MainFiltersAction => {
  return {
    type: MainFiltersActionType.UpdateMainFilters,
    payload,
  };
};

export const updateMainFiltersPeriod = (payload: BaseTimePeriod): MainFiltersAction => {
  return {
    type: MainFiltersActionType.UpdateMFPeriod,
    payload,
  };
};

export const updateMainFiltersPeriodicity = (payload: Periodicity): MainFiltersAction => {
  return {
    type: MainFiltersActionType.UpdateMFPeriodicity,
    payload,
  };
};

export const updateMainFiltersComparisonPeriod = (payload: RelativePeriod | BaseTimePeriod): MainFiltersAction => {
  return {
    type: MainFiltersActionType.UpdateMFComparisonPeriod,
    payload,
  };
};

export const updateMainFiltersCustomMonthsPeriodState = (payload: CustomMonthsPeriodState): MainFiltersAction => {
  return {
    type: MainFiltersActionType.UpdateMFCustomMonthsPeriodState,
    payload,
  };
};

export const updateMainFiltersCustomWeeksPeriodState = (payload: CustomWeeksPeriodState): MainFiltersAction => {
  return {
    type: MainFiltersActionType.UpdateMFCustomWeeksPeriodState,
    payload,
  };
};

export type MainFiltersAction =
  | UpdateMainFiltersAction
  | UpdateMFPeriod
  | UpdateMFPeriodicity
  | UpdateMFComparisonPeriod
  | UpdateMFCustomMonthsPeriodState
  | UpdateMFCustomWeeksPeriodState;

type UpdateMainFiltersAction = ActionType<MainFiltersActionType.UpdateMainFilters> & {
  payload: UpdateMainFiltersPayload;
};

type UpdateMFPeriod = ActionType<MainFiltersActionType.UpdateMFPeriod> & {
  payload: BaseTimePeriod;
};

type UpdateMFPeriodicity = ActionType<MainFiltersActionType.UpdateMFPeriodicity> & {
  payload: Periodicity;
};

type UpdateMFComparisonPeriod = ActionType<MainFiltersActionType.UpdateMFComparisonPeriod> & {
  payload: RelativePeriod | BaseTimePeriod;
};

type ActionType<MainFiltersActionType> = {
  type: MainFiltersActionType;
};

type UpdateMFCustomMonthsPeriodState = ActionType<MainFiltersActionType.UpdateMFCustomMonthsPeriodState> & {
  payload: CustomMonthsPeriodState;
};

type UpdateMFCustomWeeksPeriodState = ActionType<MainFiltersActionType.UpdateMFCustomWeeksPeriodState> & {
  payload: CustomWeeksPeriodState;
};
